/*eslint-disable */

import axios from 'axios';
import batchPatient from './batch-patients-data-use/index.vue';
import {
mapGetters,
} from 'vuex';
import singlePatient from './signle-patient-data-use/index.vue';

export default {
  name: 'new-model-use',
  components: {
    'single-patient' : singlePatient,
    'batch-patient' : batchPatient
  },
  props: [],
  data() {
    return {
      submitted:false,
      selectedModelId:'',
      model_name:'',
      selectedModelDetails:null,
      selection_type:'single_patient',
      labelDescList:[],
      labelDescListNext:false,
      modelIsPublic:Boolean
    }
  },
  computed: {
    ...mapGetters([
      'getModelsDetailsByIdGetters'
    ]),
    getCreateAlgoListFun(){
      this.selectedModelDetails = this.$store.getters.getModelsDetailsByIdGetters.data;
      return
    },
    setInitialStatesOfModel(){
      if(this.selectedModelDetails){
        this.model_name = this.selectedModelDetails.name 
        this.modelIsPublic = this.selectedModelDetails.is_public
      }
      return
    }
  },
  mounted() {
    this.getCreateAlgoListFun
    this.setInitialStatesOfModel
    this.selectedModelId = this.$route.params.useModelsId
      this.$store.dispatch('getAttrOfTrainedForUseModelsFun',{id:this.$route.params.useModelsId}).then((res)=>{
        this.labelDescList = res.data.data.results
        this.labelDescListNext = res.data.data.next
      })
  },
  methods: {
    nextDescribeListMethod(url){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          axios.get(url).then((response) => {
              this.labelDescListNext = response.data.data.next
              this.labelDescList = [].concat(this.labelDescList, response.data.data.results);
              this.submitted = false
            });
          return;
        }
      })
    },
    selectedOptionMethod(item){
      this.selection_type = item
    }
  },
  watch:{
    getCreateAlgoListFun(){
      return this.$store.getters.getModelsDetailsByIdGetters
    },
    setInitialStatesOfModel(){
      if(this.selectedModelDetails){
        this.model_name = this.selectedModelDetails.name 
        this.modelIsPublic = this.selectedModelDetails.is_public
      }
      return
    }
  }
}